/**
 * Normalize sail number for storage: uppercase, trim, collapse whitespace,
 * strip rating-system suffixes (-ORC, -IRC) that some platforms append.
 * "can 441" → "CAN 441", " USA-592 " → "USA-592", "CAN 3005-ORC" → "CAN 3005"
 */
export function normalizeSailNumber(raw) {
    return raw
        .trim()
        .toUpperCase()
        .replace(/-(ORC|IRC)$/i, '') // Strip rating-system suffixes
        .replace(/\s+/g, ' ');
}
/**
 * Normalize a sail number for durable URL/object identity.
 * "USA 1313" and "USA-1313" both become "USA1313".
 */
export function normalizeSailKey(raw) {
    return normalizeSailNumber(raw).replace(/[^A-Z0-9]/g, '');
}
/**
 * Format sail number for display: ensure space between country prefix and number.
 * "CAN441" → "CAN 441", "CAN-441" → "CAN 441", "441" → "441" (no prefix, no change)
 */
export function formatSailNumber(raw) {
    const normalized = normalizeSailNumber(raw);
    // Match 2-3 letter country code followed immediately by digits (no separator)
    return normalized.replace(/^([A-Z]{2,3})[-]?(\d)/, '$1 $2');
}
//# sourceMappingURL=sail-number.js.map